import StudentPage from './screens/StudentPage';
import StudentCalif from './screens/StudentCalif';

const routes = [
  {
    path: "/students/:id",
    exact: true,
    name: "Ficha del Alumno",
    icon: "nc-icon nc-circle-10",
    component: StudentPage,
    layout: "/admin",
    sidebar: false,
    roleID: ['STUDENT_PROFILE','TUTOR']
  } ,
  {
    path: "/my-reports",
    exact: true,
    name: "Boletines",
    icon: "fa fa-graduation-cap",
    component: StudentCalif,
    layout: "/admin",
    sidebar: true,
    roleID: 'STUDENT'
  } ,

]
  
export default routes;